import React, { Component } from "react";
import { RVEnvironment, SearchOption } from "./api/entities";
import { connect } from "react-redux";
import { Property, RVDocument } from "./api/Property";
import { RVLookup, RVLookupX } from "./api/api";
import { IStore } from "@my-dld/reducers/store";

export interface IRVContext {
	env: RVEnvironment;
	properties?: Property[];
	documents?: RVDocument[];
	searchOption?: SearchOption;
	reason?: RVLookup | RVLookupX;
	comment?: string;
}

export const defaultEnv: RVEnvironment = {
	isEjariUser: false,
	isManagementCompany: false,
	userTypeId: 0,
	editableEid: false,
	editablePhone: false,
};

export const defRVContext: IRVContext = {
	env: defaultEnv,
	documents: [],
	comment: undefined,
	properties: [],
	reason: undefined,
	searchOption: undefined,
};

const RVContext = React.createContext( defRVContext );

export default RVContext;

class Wrapper extends Component<IRVContext> {
	render() {
		return (
			<RVContext.Provider value={ this.props }>
				{ this.props.children }
			</RVContext.Provider>
		);
	}
}

function mapStateToProps( state: IStore ) {
	return {
		...state.RValuation,
	};
}

export const RvContextWrapper = connect( mapStateToProps )( Wrapper );
